import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';

@Injectable()
export class FilterEmitterService {

    private facetSubject = new ReplaySubject<Facet>();
    private facetListSubject = new ReplaySubject<Facet[]>();

    constructor() { }

    watchFilter(): Observable<Facet> {
        return this.facetSubject.asObservable();
    }

    watchFilterList(): Observable<Facet[]> {
        return this.facetListSubject.asObservable();
    }

    emitFilter(facet: Facet) {
        this.facetSubject.next(facet);
    }

    emitFilterList(facetList: Facet[]) {
        this.facetListSubject.next(facetList);
    }

}
